import React from 'react';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Text } from 'apps/auth/components/common/Text/Text';
import { logInfo } from 'apps/auth/helpers/clientLogger';

import { BalanceContainer, PseudoDropdown, Sum, SumContainer } from './styles';

const Balance = () => {
    // todo hasCurrencyIcon. Если есть иконка, тогда иконка, иначе ISO
    const hasCurrencyIcon = false;

    return (
        <BalanceContainer>
            <SumContainer
                // todo showCursor if several balances
                $showCursor={false}
                onClick={() => {
                    logInfo('show popup');
                }}
            >
                <Sum>
                    {hasCurrencyIcon ? (
                        <Text size={'display1'}>100</Text>
                    ) : (
                        <>
                            <Text size={'display1'}>100</Text>
                            <Text size={'display1'} smallCaps leftSpacer>
                                eur
                            </Text>
                        </>
                    )}
                </Sum>
                <PseudoDropdown>
                    <Text color={'secondary'}>Euro</Text>
                    <Icon name={'chevron-down'} color={'secondary'} size={'16px'} leftIndent={'2px'} />
                </PseudoDropdown>
            </SumContainer>
        </BalanceContainer>
    );
};

export default Balance;
